export const DAR_HELP_DOMAIN = "dar" as const;

export const DAR_HELP_SCREENS = {
  form: "dar.form",
  list: "dar.list",
} as const;

export const DAR_FORM_HELP_KEYS = {
  property: "dar.form.property",
  type: "dar.form.type",
  code: "dar.form.code",
  date: "dar.form.date",
  time: "dar.form.time",
  details: "dar.form.details",
  images: "dar.form.images",
  sendNotification: "dar.form.send_notification",
  includeGpsCoordinates: "dar.form.include_gps_coordinates",
  submit: "dar.form.submit",
} as const;

export const DAR_LIST_HELP_KEYS = {
  search: "dar.list.search",
  filters: "dar.list.filters",
  new: "dar.list.new",
  rows: "dar.list.rows",
  row: "dar.list.row",
  rowActions: "dar.list.row_actions",
  actionTransfer: "dar.list.action_transfer",
  actionView: "dar.list.action_view",
  actionEdit: "dar.list.action_edit",
  actionDelete: "dar.list.action_delete",
} as const;

export const DAR_HELP_TOURS = {
  listIntro: "dar.list.intro",
  formCreate: "dar.form.create",
} as const;
